import { Component, Input, OnDestroy } from '@angular/core';
import { IMiningToast } from '../../interfaces/mining-toast';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-mining-toast',
  templateUrl: './mining-toast.component.html',
  styleUrls: ['./mining-toast.component.scss'],
})
export class MiningToastComponent implements OnDestroy {
  public toast: IMiningToast;
  public showToast: boolean;
  public closeToast: Subject<boolean>;

  @Input()
  public set miningToast(miningToast: IMiningToast) {
    this.toast = miningToast;

    if (miningToast && miningToast.config) {
      this.showToast = true;
      setTimeout(() => (this.showToast = false), miningToast.config.delay - 500); // Fade-out time
      setTimeout(() => (this.toast = null), miningToast.config.delay - 250);
    }
  }

  constructor() {
    this.closeToast = new Subject<boolean>();
  }

  /**
   * Function that allow execute a callback on click the close button
   */
  public onClose(): void {
    if (this.toast.config.closeOnClick) {
      this.closeToast.next(true);
    }
  }

  /**
   * Function that executes when the component is destroyed
   */
  public ngOnDestroy(): void {
    this.closeToast.complete();
  }
}
